import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { QuestionIcon } from 'foundations-assets/icons/components/QuestionIcon';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const SmartPropertyStatusQuestionIcon = () => {
  return /*#__PURE__*/_jsx(IconCircle, {
    backgroundColor: "fill-accent-red-default",
    color: "fill-surface-default",
    icon: QuestionIcon,
    marginInlineEnd: "100",
    padding: "25",
    size: "100",
    verticalAlign: "0"
  });
};
const SmartPropertyStatusWarningIcon = () => {
  return /*#__PURE__*/_jsx(IconHolder, {
    color: "fill-accent-red-default",
    icon: WarningIcon,
    marginBlock: "0",
    marginInlineEnd: "100",
    padding: "0",
    size: "400",
    verticalAlign: "-2px"
  });
};
const getTooltipPropsByStatusAndMetadata = (status, metadata) => {
  if (status === 'COMPLETE_NO_RESULT') {
    return {
      headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusQuestionIcon, {}),
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyStatus.unableToAnswerHeader"
      }),
      bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyStatus.noResultFound.bodyHeader"
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyStatus.noResultFound.body"
      })
    };
  }
  switch (metadata.error) {
    case 'GENERATIVE_AI_CUSTOMER_CONVERSATION_DISABLED':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.customerConversationDisabled.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.customerConversationDisabled.body"
        })
      };
    case 'NO_TRANSCRIPT_DATA':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.noTranscriptData.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.noTranscriptData.body"
        })
      };
    case 'OBJECT_NOT_FOUND':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.objectNotFound.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.objectNotFound.body"
        })
      };
    case 'INVALID_PROPERTY':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidProperty.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidProperty.body"
        })
      };
    case 'MISSING_PROPERTY_POINTER':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.missingPropertyPointer.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.missingPropertyPointer.body"
        })
      };
    case 'INVALID_PROPERTY_POINTER':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidPropertyPointer.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidPropertyPointer.body"
        })
      };
    case 'EMPTY_PROPERTY_POINTER':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.emptyPropertyPointer.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.emptyPropertyPointer.body"
        })
      };
    case 'INTERNAL_AGENT_ERROR':
    case 'INVALID_AGENT_RESULT':
    case 'CRM_WRITE_ERROR':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.internalAgentError.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.internalAgentError.body"
        })
      };
    case 'ENRICHMENT_DEADLINE_EXCEEDED':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.enrichmentDeadlineExceeded.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.enrichmentDeadlineExceeded.body"
        })
      };
    case 'INSUFFICIENT_CREDITS':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.insufficientCredits.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.insufficientCredits.body"
        })
      };
    case 'INVALID_DOMAIN':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidDomain.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidDomain.body"
        })
      };
    case 'INVALID_AGENT_RESULT_PII_DETECTED':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusQuestionIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.unableToAnswerHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidAgentResultPIIDetected.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidAgentResultPIIDetected.body"
        })
      };
    case 'INVALID_TOKEN':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidToken.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidToken.body"
        })
      };
    case 'EMPTY_TOKEN':
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.emptyToken.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.emptyToken.body"
        })
      };
    default:
      return {
        headingIcon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.smartPropertyErrorHeader"
        }),
        bodyHeader: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.unknownError.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.unknownError.body"
        })
      };
  }
};
export default getTooltipPropsByStatusAndMetadata;